import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIROLEMAPPING, EMAILCONFIG } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { APIROLEMAPPING_API, BaseGatewayAuth } from '../../utils/apiUrl.js';
import { userManager } from '@app/utils/oidc';
import { FLASH_KEY } from '@app/utils/define';

export const apiRoleMappingPagingAction = createAsyncThunk(
    APIROLEMAPPING.GET_PAGING,
    async (model, { rejectWithValue }) => {
        try {
            // Fetch API role mappings
            const response = await Get(APIROLEMAPPING_API.GET_PAGING, null, model);

            // Fetch user data
            const user = await userManager.getUser();

            // Prepare the data to return
            const userRoles = user && !user.expired && user.profile?.role
                ? Array.isArray(user.profile.role)
                    ? user.profile.role
                    : [user.profile.role]
                : [];

            console.log('response', response);
            console.log('userRoles', userRoles);

            if (response) {
                const result = {
                    data: response.data || [],
                    totalRecords: response.totalRecords || 0,
                    userRoles
                };

                return result;
            } else {
                console.log("vao day ne");
                localStorage.setItem(
                    FLASH_KEY,
                    JSON.stringify({ level: 'error', text: 'Tài khoản này không được sử dụng phần mềm này' })
                );

                userManager.removeUser();
                window.location.href = `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + "/")}`;

                state.isLoggedIn = false;
                state.error = null;

                return null;
            }

        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const initialState = {
    listApiRoleMapping: [],
    totalApiRoleMapping: 0,
    status: 'idle'
    // apiRoleMappingItem: null
};
export const apiRoleMappingSlice = createSlice({
    name: APIROLEMAPPING.NAME_SLICE,
    initialState,
    reducers: {
        filterListApiRoleMapping: (state, action) => {
            state.listApiRoleMapping =
                state.listApiRoleMapping.length > 0
                    ? state.listApiRoleMapping.filter(
                        (x) => x.id !== action.payload
                    )
                    : [];
            state.totalApiRoleMapping -= 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(apiRoleMappingPagingAction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(apiRoleMappingPagingAction.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.listApiRoleMapping =
                    action.payload && action.payload.data
                        ? action.payload.data
                        : [];

                console.log('action.payload.userRoles', action.payload.userRoles);
                // Append Account permission if user has the 'admin' role
                if (action.payload && action.payload.userRoles.includes('admin')) {
                    state.listApiRoleMapping.push({
                        id: 'account',
                        controller: 'Account', // Use 'Account' to match routes.js
                        action: 'GetAllByPaging',
                        lstAllowedRoles: [
                            { id: 'admin', name: 'admin' }
                        ]
                    }, {
                        id: 'openiddictapplication',
                        controller: 'OpeniddictApplication', // Use 'OpeniddictApplication' to match routes.js
                        action: 'GetAllByPaging',
                        lstAllowedRoles: [
                            { id: 'admin', name: 'admin' }
                        ]
                    }, {
                        id: 'roleAccount',
                        controller: 'Role', // Use 'OpeniddictApplication' to match routes.js
                        action: 'GetAllByPaging',
                        lstAllowedRoles: [
                            { id: 'admin', name: 'admin' }
                        ]
                    });
                    state.totalApiRoleMapping = (action.payload.totalRecords || 0) + 1;
                } else {
                    state.totalApiRoleMapping = action.payload.totalRecords || 0;
                }
            })
            .addCase(apiRoleMappingPagingAction.rejected, (state) => {
                state.status = 'failed';
            });
    }
});

export const { filterListApiRoleMapping } = apiRoleMappingSlice.actions;

export default apiRoleMappingSlice.reducer;
